export default __webpack_public_path__ + "b7538ebf1d9d7968c39fb14f52c5ab4b.png";